import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

export const useIsEmailHubNewsletterPhaseEEnabled = (): boolean => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(
    currentCommunitySettings?.email_hub_newsletter_phase_e_enabled,
  );
};
